import { getApp } from "firebase/app";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { getAuth } from "firebase/auth";
import { compressImage } from "./imageCompress";

function dataURLtoBlob(dataUrl) {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new Blob([u8arr], { type: mime });
}

/**
 * Compress, upload to Firebase Storage under `cms/…`, return public download URL.
 * Requires signed-in user (Storage rules: write if request.auth != null).
 */
export async function uploadCmsImageFile(file, storagePathPrefix) {
  const app = getApp();
  const auth = getAuth(app);
  if (!auth.currentUser) {
    throw new Error("You must be signed in to upload images.");
  }
  const dataUrl = await compressImage(file);
  const blob = dataURLtoBlob(dataUrl);
  const safePrefix = String(storagePathPrefix || "cms/misc").replace(/^\/+|\/+$/g, "");
  const objectPath = `${safePrefix}/${Date.now()}_${Math.random().toString(36).slice(2, 10)}.jpg`;
  const storage = getStorage(app);
  const storageRef = ref(storage, objectPath);
  await uploadBytes(storageRef, blob, { contentType: "image/jpeg" });
  const url = await getDownloadURL(storageRef);
  return { url, storagePath: objectPath };
}

/**
 * Delete a CMS object from Firebase Storage. Only paths under `cms/` are allowed.
 * Resolves without throwing when path is missing or not deletable (caller can still drop from Firestore).
 */
export function deleteCmsStorageFileByPath(storagePath) {
  if (!storagePath || typeof storagePath !== "string") {
    return Promise.resolve();
  }
  const p = storagePath.replace(/^\/+|\/+$/g, "");
  if (!p.startsWith("cms/")) {
    console.warn("[cms] Skipped storage delete (not under cms/):", storagePath);
    return Promise.resolve();
  }
  const storage = getStorage(getApp());
  return deleteObject(ref(storage, p));
}
